import moment from 'moment';

const config = {
	currency(value) {
		if (isNaN(value)) {
			return value;
		}

		const formatter = new Intl.NumberFormat('id-ID');

		if (value == null) {
			return value;
		}
		return formatter.format(value)
	},
	capitalize(value) {
		const words = value.split(" ");

		for (let i = 0; i < words.length; i++) {
			if (words[i][0]) {
				words[i] = words[i][0].toUpperCase() + words[i].substr(1).toLowerCase();
			}
		}

		return words.join(" ");
	},
	truncate(text, length = 20, clamp = '...', front = true) {
		var node = document.createElement('div');
		node.innerHTML = text;
		var content = node.textContent;
		if (front === true) {
			return content.length > length ? content.slice(0, length) + clamp : content;
		} else {
			return content.length > length ? clamp + content.substr(content.length - length) : content;
		}
	},
	ucword(value) {
		if (!value) return '';
		value = value.toString();
		value = value.toLowerCase();
		return (value + '').replace(/^([a-z])|\s+([a-z])/g, function ($1) {
			return $1.toUpperCase();
		});
	},
	formatDate(value) {
		if (value) {
			let year = moment(value).format('YYYY');
			let this_year = moment().year()

			if (year == this_year) {
				return moment(value)
					.locale('id-ID')
					.format("DD MMM YYYY");
			} else {
				return moment(value)
					.locale('id-ID')
					.format("DD MMM YYYY");
			}
		}
	},
	formatDateTime(value) {
		if (value) {
			let year = moment(value).format('YYYY');
			let this_year = moment().year()
			if (year === this_year) {
				return moment(value)
					.locale('id-ID')
					.format("DD MMM, HH:mm");
			} else {
				return moment(value)
					.locale('id-ID')
					.format("DD MMM YYYY, HH:mm");
			}
		}
	},
	formatTime(value) {
		if (value) {
			return moment(value).format("hh:mm");
		}
	},
	jsonDisplay(value) {
		// return ;
		return JSON.stringify(JSON.parse(value), null, 2)
	}
}

export default config;